import TopNav from "../components/TopNav";
import { Hero, MissionSection } from "./landing/Hero";
import { TracksSection, ModelSection, EvidenceSection, MeasuresSection } from "./landing/Sections";
import { CtaSection, TacticalFooter } from "./landing/Cta";

export default function Landing() {
  return (
    <div className="min-h-screen bg-[var(--bg)]">
      <TopNav landing />
      <Hero />
      <MissionSection />
      <TracksSection />
      <ModelSection />
      <EvidenceSection />
      <MeasuresSection />
      <CtaSection />
      <TacticalFooter />
    </div>
  );
}
